<template>
  <div class="box">
      <img src="@/assets/topbg1.png" alt="" style="width:100%;position: absolute;top: 0;left: 0;">
      <div class="box-margin">
          <div class="content-box">
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red">*</span>客户名称</div>
                  <div class="pub-input">
                      <input
                          style="background: #00000000;"
                          type="text"
                          class="input-gh"
                          v-model="contactPerson"
                          placeholder="请填写客户名称"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red"></span>联系电话</div>
                  <div class="pub-input">
                      <input
                      
                          type="text"
                          class="input-gh"
                          v-model="mobile"
                          placeholder="请填写联系电话"
                      />
                  </div>
              </div>
              <div class="box-item">
                  <div style="font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 18px;color: #333333;line-height: 25px;text-align: left;font-style: normal;"> <span style="color: red"></span>联系人</div>
                  <div class="pub-input">
                      <input
                      
                          type="text"
                          class="input-gh"
                          v-model="person"
                          placeholder="请填写联系人"
                      />
                  </div>
              </div>
              <div>
                  <div
                      class="share-url"
                      @click="submitOrEditData">
                      确定
                  </div>
              </div>
          </div>
          <div style="height: 15px"></div>
      </div>
      
  </div>
</template>
<script>
import { user } from "@/api";
import Config from "@/config";
import authImg from "@/components/temp/authImg.vue";
let lsDate = "";
import {
  Popup,
  Picker,
  ImagePreview,
  Loading,
  Toast,
  Empty,
  Dialog,
  Calendar,
} from "vant";
// import { compressImage } from "@/utils/CompressImageUtils";
export default {
  components: {
      authImg,
      VanLoading: Loading,
      VanPopup: Popup,
      VanPicker: Picker,
      VanEmpty: Empty,
      VanCalendar: Calendar,
  },
  data() {
      return {
          Config,
          token:'',
          productName:"",
          productPrice:"",
          specModel:"",
          contactPerson:"",
          mobile:"",
          maintenanceContent:"",
          maintenanceComp:"",
          showDialog: false,
          showTxDialog: false,
          showCalendar: false,
          fontSizeValue: 0,
          qwrqText: "",
          minDate: "",
          maxDate: "",
          columns: [
              "8:00-9:00",
              "9:00-10:00",
              "10:00-11:00",
              "13:30-14:30",
              "14:30-15:30",
              "15:30-16:30",
          ],
          showQwrqPopup: false,
          status: "",
          remarks: "",
          isAllFalse: false,
          isSel: 2,
          isVip: true,
          hisId: "",
          isLoading: false,
          sex: 1, // 性别 1男2女
          jzlb: 1,
          realName: "", // 真实名称
          idCardNumber: "", // 证件号码
          mobile: "", // 联系电话
          age: "", // 年龄
          jzxq: 1, // 就诊需求
          zjlx: "", // 证件类型
          zjlxObj: {}, // 证件类型
          qwyy: "", // 期望医院
          qwyyObj: {}, // 期望医院
          tsRemark: "",
          zjlxCom: [{
            text: "1年",
            title:"1年",
            value: 1
          }, {
            text: "2年",
            title:"2年",
            value: 2
          }, {
            text: "3年",
            title:"3年",
            value: 3
          }, {
            text: "4年",
            title:"4年",
            value: 4
          }, {
            text: "5年",
            title:"5年",
            value: 5
          }, {
            text: "6年",
            title:"6年",
            value: 6
          }, {
            text: "7年",
            title:"7年",
            value: 7
          }, {
            text: "8年",
            title:"8年",
            value: 8
          }, {
            text: "9年",
            title:"9年",
            value: 9
          }, {
            text: "10年",
            title:"10年",
            value: 10
          }],
          jzyyCom: [],
          slhCom: {},
          jyjcbgList: [],
          jyjcbgStringList: [],
          showZjlxPopup: false,
          showQwyyPopup: false,
          qywxId: "",
          failEdit: true, //是否可以填写
          isCurrentTime: false,
          customerId:"",
          person: ""
      };
  },
  mounted() {
      this.isLoading = false;
      if(this.getQueryString("customer")) {
        this.customerId = JSON.parse(this.getQueryString("customer")).id;
        this.contactPerson = JSON.parse(this.getQueryString("customer")).name;
        this.mobile = JSON.parse(this.getQueryString("customer")).mobile;
        this.person = JSON.parse(this.getQueryString("customer")).person;
      }
      document.title = "填写信息";
  },
  methods: {
      
      submitOrEditData() {
          if (this.contactPerson == "") {
              Toast.fail("请填写客户对接人");
              return;
          }
          if (this.customerId == "") {
              this.submitData();
          } else {
              this.editData();
          }
          
      },
      convertToUpperCase(idNumber) {
          return idNumber.toLocaleUpperCase(); // 使用 toLocaleUpperCase() 函数将所有字符转换为大写
      },
      submitData() {
          this.isLoading = true;
          let params = {
            name: this.contactPerson,
            mobile: this.mobile,
            person: this.person
          };
          user.addCustomer(params).then((res) => {
            this.isLoading = false;
              if (res.data.code == 200) {
                Toast.success("新增成功");
                this.$router.back()
              } else {
                  Toast.fail(res.data.message);
              }
          });
      },
      editData() {
          this.isLoading = true;
          let params = {
                id: this.customerId,
                name: this.contactPerson,
                mobile: this.mobile,
                person: this.person
          };
          user.editCustomer(params).then((res) => {
            this.isLoading = false;
              if (res.data.code == 200) {
                  Toast.success("编辑成功");
                this.$router.back()
              } else {
                  Toast.fail(res.data.message);
              }
          });
      },
      getQueryString: function (name) {
          let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          let r = window.location.search.substr(1).match(reg);
          if (r != null) {
              return unescape(decodeURI(r[2]));
          }
      },
      delPic(index) {
          this.jyjcbgList.splice(index, 1);
          this.jyjcbgStringList.splice(index, 1);
      },
      showPic(index) {
          ImagePreview(this.jyjcbgList, index);
      },
      gzxqdClick(e) {
          this.$router.push({ name: "gzxqd", query: e });
      },
      isUserSex(e) {
          this.sex = e;
      },
      isJzlb(e) {
          this.jzlb = e;
      },
      isJzxq(e) {
          this.jzxq = e;
      },
      parentData(e) {
          this.isSel = e;
      },
      selZjlx() {
          this.showZjlxPopup = true;
      },
      selQwyy() {
          this.showQwyyPopup = true;
      },
      onConfirm(value) {
          this.zjlx = value.text;
          this.zjlxObj = value;
          this.showZjlxPopup = false;
      },
      onCancel() {
          this.showZjlxPopup = false;
      },
      onConfirm1(value) {
          this.qwyy = value.text;
          this.qwyyObj = value;
          this.showQwyyPopup = false;
      },
      onCancel1() {
          this.showQwyyPopup = false;
      },
      changeDzms() {
          if(this.fontSizeValue == 0) {
              this.fontSizeValue = 8;
          } else {
              this.fontSizeValue = 0;
          }
          
      },
  },
};
</script>
<style scoped>
.pub-input{
  font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;margin-top: 10px;
}
/deep/ .van-calendar__confirm {
  height: 45px !important;
  font-size: 16px;
}
.boda {
  width: 20px;
  height: 20px;
  font-size: 12px;
  background: rgba(236, 154, 48, 0.6);
  padding: 2px 5px;
  border-radius: 3px;
  color: #fff;
  margin-left: 10px;;
}
.info-box {
  width: 92%;
  margin-left: 4%;
  padding: 5px 0 10px 0;
}
input {
  padding: 0;
}
textarea {
  padding: 0;
}
.box-margin {
  width: 92%;
  margin-left: 4%;
  position: relative;
  top: 10px;
}
.bg-title {
  width: 100%;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.x-box1 .img-list:nth-child(4) {
  margin-right: 0;
}

.x-box1 .img-list:nth-child(8) {
  margin-right: 0;
}
.img-list {
  position: relative;
  width: 44px;
  height: 44px;
  margin-bottom: 8px;
  margin-right: 2%;
}
.dele {
  width: 22px;
  height: 22px;
  position: absolute;
  top: -7px;
  right: -7px;
  background: #fff;
  border: 2px solid #fff;
  border-radius: 50%;
}
.add-img1 {
  position: relative;
  width: 44px;
  display: flex;
  align-items: center;
  height: 44px;
  margin-bottom: 7px;
}

.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  width: 100%;
  height: 87px;
  align-items: center;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file input {
  width: 100%;
  height: 87px;
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}

.file:hover {
  color: #004974;
  text-decoration: none;
}

.img-size1 {
  width: 21px;
  height: 18px;
}
.box {
  height: 100vh;
  position: static;
  background: #eef7f8;
}
.bar {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.box-item:last-child {
  border-bottom: none;
}
.share-url {
  width: 92%;
  margin-left: 4%;
  height: 49px;
  background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);
  line-height: 49px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  border-radius: 8px;
  margin-top: 15px;
  cursor: pointer;
}
.content-box {
  width: 100%;
  margin-top: 7px;
  background: #fff;
  padding-bottom: 15px;
  border-radius: 8px;
  padding-top: 5px;
}
.box-item {
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 19px;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item2 {
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 19px;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item3 {
  /* height: 121px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 19px;
  /* border-bottom: 2px solid #f2f2f2; */
}
.box-item4 {
  /* height: 121px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 2px solid #f2f2f2; */
  background: #3985DE;
  padding: 10px;
  border-radius: 8px;
  color: #fff;
  font-size: 12px;;
  box-sizing: border-box;
  margin-top: 19px;
}
.box-item6 {
  /* height: 121px; */
  position: absolute;
  left: 0;
  top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 2px solid #f2f2f2; */
  background: rgba(236, 165, 48, 0.76);
  padding: 5px 10px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  color: #fff;
}
.box-item3 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
  /* margin-top: 15px; */
  margin-bottom: 10px;
}
.box-item3 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.box-item2 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item2 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.box-item > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.box-item1 {
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 1px solid #f2f2f2; */
  margin-top: 19px;
}
.box-item1 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item1 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 8px;
  justify-content: space-between;
}
.btm-icon {
  width: 12px;
  margin-right: 15px;
}
.title {
  font-size: 15px;
  color: #c0c0c0;
  margin-left: 14px;
}
.user-type {
width: 48%;
display: flex;
align-items: center;
text-align: center;
line-height: 44px;
cursor: pointer;
/* margin-right: 15px; */
/* margin-top: 14px; */
border-radius: 8px;
font-family: PingFang-SC, PingFang-SC;
font-weight: 500;
font-size: 14px;
color: #333333;
text-align: center;
font-style: normal;
}
.user-type1 {
width: 31%;
display: flex;
align-items: center;
text-align: center;
line-height: 44px;
cursor: pointer;
/* margin-right: 15px; */
/* margin-top: 14px; */
border-radius: 8px;
font-family: PingFang-SC, PingFang-SC;
font-weight: 500;
font-size: 14px;
color: #333333;
text-align: center;
font-style: normal;
}
.redbtn-icon {
  width: 18px;
  margin-right: 8px;
}
.input-gh {
  width: 80%;
  border: none;
  /* margin-top: 8px; */
  font-size: 15px;
  padding: 0 14px;
  box-sizing: border-box;
  background: #00000000;
}
.input-xq {
  width: 100%;
  border: none;
  margin-top: 8px;
  height: 66px;
  font-size: 15px;
  resize: none;
}
input::placeholder {
  color: #c0c0c0;
}
textarea::placeholder {
  color: #c0c0c0;
}
.list-item {
  margin-bottom: 10px;
}
.leftbtn {
  display: flex;
  align-items: center;
}
.gzxqd {
  height: 26.5px;
  border: 1px solid #079bab;
  color: #079bab;
  line-height: 26.5px;
  font-size: 12px;
  text-align: center;
  padding: 0 10px;
  border-radius: 26px;
}
.yjqk {
  position: fixed;
  top: 300px;
  right: 0;
  background: #3985DE;
  padding: 5px 10px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  color: #fff;
  z-index: 99;
  font-size: 14px;
}
.box-dzms{position: absolute;top: 20px;;right: 0;display: flex;align-items: center;justify-content: center;border: 1px solid #079bab;padding: 2px 5px;border-radius: 35px;font-size: 12px;color: #00AC97;}
</style>
